<template>
  <v-container fluid>
    <v-layout row
              wrap>
      <v-flex xs12>
        <el-transfer v-model="spotsToModify"
                     :titles="[$t('private_modal_availabilities_modify_spots_out'), $t('private_modal_availabilities_modify_spots_in')]"
      
                     :data="spots"
                     @change="innerSpotsChanged">
        </el-transfer>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import store from '@/store';
import _ from 'lodash';
import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';

const onSpotsChanged = 'on-spots-changed';

export default {
  name: 'spots-multiple-select',
  data() {
    return {
      spots: [],
      spotsToModify: []
    };
  },
  created() {
    EventBus.$on(keys.eventOnLanguageChanged, this.updateLanguage);
  },
  destroyed() {
    EventBus.$off(keys.eventOnLanguageChanged, this.updateLanguage);
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.spotsToModify = [];
    },
    reloadSpots() {
      let tempSpots = store.state.parkingSpots;
      this.spots = _.cloneDeep(tempSpots);
      this.$nextTick(() => {
        this.updateLanguage();
      });
    },
    updateLanguage() {
      _.each(this.spots, spot => {
        if (typeof spot.originalLabel === 'undefined') {
          spot.originalLabel = spot.label;
        }
        spot.statusText = '-';
        switch (spot.status) {
          case 'AVAILABLE':
            spot.statusText = this.$i18n.t('private_parking_activity_spots_spots_status_1');
            break;
          case 'RESERVED':
            spot.statusText = this.$i18n.t('private_parking_activity_spots_spots_status_2');
            break;
          case 'IN_USE':
            spot.statusText = this.$i18n.t('private_parking_activity_spots_spots_status_3');
            break;
          case 'WRONG':
            spot.statusText = this.$i18n.t('private_parking_activity_spots_spots_status_4');
            break;
          case 'NO_AVAILABLE_FREE':
            spot.statusText = this.$i18n.t('private_parking_activity_spots_spots_status_5');
            break;
          case 'NO_AVAILABLE_OCCUPIED':
            spot.statusText = this.$i18n.t('private_parking_activity_spots_spots_status_6');
            break;
          case 'BROKEN':
            spot.statusText = this.$i18n.t('private_parking_activity_spots_spots_status_7');
            break;
          default:
            spot.statusText = '-';
            break;
        }
        spot.key = spot.id;
        spot.label = `${this.$i18n.t('private_modal_availabilities_modify_spots_prefix')} ${spot.originalLabel} (${spot.statusText})`;
      });
    },
    innerSpotsChanged() {
      this.$emit(onSpotsChanged, this.spotsToModify);
    }
  }
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/commons/SpotsMultipleSelect.vue